module.exports = __webpack_public_path__ + "img/ic_fist@3x.dadd12c4.png";